'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { useTracker } from '@lichtblick/tracker';
import { type FC, useCallback, useEffect, useState } from 'react';
import { CityInput } from '../OAllInOneCalculator/CityInput';
import { useVpCodes } from '../OAllInOneCalculator/useVpCodes';
import styles from './all-in-one-calculator.module.scss';

export const HeatingSubcalculator: FC<{ powerCloudCampaignId?: string }> = ({ powerCloudCampaignId }) => {
  const [postcode, setPostcode] = useState('');
  const [city, setCity] = useState('');

  const { computeVpCodes } = useVpCodes();
  const { trackCustomEvent } = useTracker();

  const cityChangeHandler = useCallback((city: string, postcode: string) => {
    setCity(city);
    setPostcode(postcode);
  }, []);

  const [vpCodes, setVpCodes] = useState<{
    uvp?: string;
    vp?: string;
  }>({});

  useEffect(() => {
    setVpCodes(computeVpCodes());
  }, [computeVpCodes]);

  return (
    <form
      action="/waermestrom-checkout/"
      method="GET"
      data-testid="heat-form"
      onSubmit={(e) => {
        if (e.currentTarget.checkValidity()) {
          trackCustomEvent({
            eventName: 'tariff_calculator_show_tariffs',
            customProps: { product: 'WärmeStrom', zip_code: postcode },
          });
        }
      }}
    >
      <div className={styles['input-grid']}>
        <CityInput onChange={cityChangeHandler} />
      </div>

      <input name="ort" type="hidden" value={city} />
      <input name="plz" type="hidden" value={postcode} />
      {Boolean(powerCloudCampaignId) && <input name="cam" type="hidden" value={powerCloudCampaignId} />}
      {Boolean(vpCodes.vp) && <input name="vp" type="hidden" value={vpCodes.vp} />}
      {Boolean(vpCodes.uvp) && <input name="uvp" type="hidden" value={vpCodes.uvp} />}
      <div className={styles['confirmation-row']}>
        <BoxCTA as="button" type="submit" data-dd-action-name="Calculator submit: WärmeStrom">
          Tarife berechnen
        </BoxCTA>
      </div>
    </form>
  );
};
